import React, { useState } from 'react';
import { BorrowerList } from '../components/BorrowerList';
import { InactiveOwnerPool } from '../components/InactiveOwnerPool';
import { Card, CardContent } from '../components/ui/Card';
import { Tabs } from '../components/ui/Tabs';
import { TrophyIcon } from 'lucide-react';
export function Dashboard() {
  const [activeTab, setActiveTab] = useState('funded');
  const [inactiveCount, setInactiveCount] = useState(12);
  const [claimedBorrowers, setClaimedBorrowers] = useState<any[]>([]);
  const handleClaim = (borrower: any) => {
    setClaimedBorrowers(prev => [...prev, borrower]);
  };
  const tabs = [{
    id: 'funded',
    label: 'My Funded Borrowers',
    count: 12 + claimedBorrowers.length
  }, {
    id: 'inactive',
    label: 'Inactive Owner Pool',
    count: inactiveCount
  }];
  return <div className="min-h-screen bg-gray-50/50" data-id="element-270">
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-271">
        <div className="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-272">
          <div data-id="element-273">
            <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-274">
              Welcome back, John
            </h1>
            <p className="text-gray-600 mt-1.5 text-lg" data-id="element-275">
              You have{' '}
              <span className="font-semibold text-blue-600" data-id="element-276">
                12 funded borrowers
              </span>{' '}
              ready for refinancing.
            </p>
          </div>

          <div className="flex items-center gap-2.5 text-sm bg-white px-4 py-2.5 rounded-lg border border-gray-200 shadow-sm text-gray-700" data-id="element-277">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse flex-shrink-0" data-id="element-278"></span>
            Market rates dropped 0.125% today
          </div>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-279">
          {/* Card 1: Leaderboard Summary */}
          <Card className="bg-gradient-to-b from-blue-50/50 to-white border-blue-100/50" data-id="element-280">
            <CardContent className="p-5 h-full flex flex-col" data-id="element-281">
              <div className="flex items-center justify-between mb-4" data-id="element-282">
                <div className="flex items-center gap-2" data-id="element-283">
                  <div className="bg-yellow-100 p-1.5 rounded-lg" data-id="element-284">
                    <TrophyIcon className="w-4 h-4 text-yellow-600" data-id="element-285" />
                  </div>
                  <h3 className="font-semibold text-blue-900 text-sm" data-id="element-286">
                    Top Converters
                  </h3>
                </div>
                <span className="text-xs font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full" data-id="element-287">
                  You are #3
                </span>
              </div>

              <div className="space-y-2.5 flex-1" data-id="element-288">
                <div className="flex items-center justify-between text-sm py-1" data-id="element-289">
                  <div className="flex items-center gap-2.5" data-id="element-290">
                    <span className="w-5 h-5 flex items-center justify-center bg-yellow-100 text-yellow-700 rounded-full text-xs font-bold flex-shrink-0" data-id="element-291">
                      1
                    </span>
                    <span className="text-gray-900 font-medium" data-id="element-292">
                      David Miller
                    </span>
                  </div>
                  <span className="text-gray-600 font-semibold tabular-nums" data-id="element-293">
                    12
                  </span>
                </div>
                <div className="flex items-center justify-between text-sm py-1" data-id="element-294">
                  <div className="flex items-center gap-2.5" data-id="element-295">
                    <span className="w-5 h-5 flex items-center justify-center bg-gray-100 text-gray-700 rounded-full text-xs font-bold flex-shrink-0" data-id="element-296">
                      2
                    </span>
                    <span className="text-gray-900 font-medium" data-id="element-297">
                      Sarah Jenkins
                    </span>
                  </div>
                  <span className="text-gray-600 font-semibold tabular-nums" data-id="element-298">
                    9
                  </span>
                </div>
                <div className="flex items-center justify-between text-sm bg-white shadow-sm ring-1 ring-blue-200 rounded-lg py-1.5 px-2 -mx-2" data-id="element-299">
                  <div className="flex items-center gap-2.5" data-id="element-300">
                    <span className="w-5 h-5 flex items-center justify-center bg-blue-100 text-blue-700 rounded-full text-xs font-bold flex-shrink-0" data-id="element-301">
                      3
                    </span>
                    <span className="text-blue-700 font-semibold" data-id="element-302">You</span>
                  </div>
                  <span className="text-blue-700 font-bold tabular-nums" data-id="element-303">
                    7
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Card 2: Volume Goal */}
          <Card data-id="element-304">
            <CardContent className="p-5 h-full flex flex-col" data-id="element-305">
              <div className="flex items-center justify-between mb-4" data-id="element-306">
                <h3 className="font-semibold text-gray-900 text-sm" data-id="element-307">
                  Monthly Goal
                </h3>
                <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-1 rounded-full" data-id="element-308">
                  Ends in 4 days
                </span>
              </div>
              <div className="flex-1 flex flex-col justify-end" data-id="element-309">
                <div className="flex justify-between text-sm mb-1" data-id="element-310">
                  <span className="text-gray-600 font-medium" data-id="element-311">
                    Refinance Volume
                  </span>
                  <span className="font-bold text-gray-900 tabular-nums" data-id="element-312">
                    75%
                  </span>
                </div>
                <div className="flex justify-between text-xs text-gray-500 mb-3" data-id="element-313">
                  <span data-id="element-314">$3.75M of $5M goal</span>
                  <span data-id="element-315">$1.25M remaining</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden" data-id="element-316">
                  <div className="bg-green-500 h-full rounded-full transition-all duration-1000 ease-out" style={{
                  width: '75%'
                }} data-id="element-317"></div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Card 3: Calls Goal */}
          <Card data-id="element-318">
            <CardContent className="p-5 h-full flex flex-col" data-id="element-319">
              <div className="flex items-center justify-between mb-4" data-id="element-320">
                <h3 className="font-semibold text-gray-900 text-sm" data-id="element-321">
                  Outreach Goal
                </h3>
                <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-1 rounded-full" data-id="element-322">
                  Daily Target
                </span>
              </div>
              <div className="flex-1 flex flex-col justify-end" data-id="element-323">
                <div className="flex justify-between text-sm mb-1" data-id="element-324">
                  <span className="text-gray-600 font-medium" data-id="element-325">Calls Made</span>
                  <span className="font-bold text-gray-900 tabular-nums" data-id="element-326">
                    45/60
                  </span>
                </div>
                <div className="flex justify-between text-xs text-gray-500 mb-3" data-id="element-327">
                  <span data-id="element-328">15 calls to go</span>
                  <span className="text-green-600 font-medium" data-id="element-329">
                    +12 from yesterday
                  </span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden" data-id="element-330">
                  <div className="bg-blue-500 h-full rounded-full transition-all duration-1000 ease-out" style={{
                  width: '75%'
                }} data-id="element-331"></div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Tables Section with Tabs */}
        <div className="w-full space-y-4" data-id="element-332">
          <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} className="mb-2" data-id="element-333" />

          {activeTab === 'funded' ? <BorrowerList claimedBorrowers={claimedBorrowers} data-id="element-334" /> : <InactiveOwnerPool onCountChange={setInactiveCount} onClaim={handleClaim} data-id="element-335" />}
        </div>
      </main>
    </div>;
}